var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIv = function SvgIv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M28.333 4.917c12.565 0 22.75 10.185 22.75 22.75 0 12.566-10.185 22.75-22.75 22.75s-22.75-10.184-22.75-22.75c0-12.565 10.185-22.75 22.75-22.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00484E",
    d: "m21.035 41.44 1.155 4.655h1.75a.583.583 0 0 0 .577-.578v-4.06h-3.482z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M19.863 41.44v4.06c0 .315.262.578.577.578h1.75v-4.656h-2.328z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00484E",
    d: "m32.655 41.44 1.155 4.655h1.75a.583.583 0 0 0 .578-.578v-4.06h-3.483z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M31.483 41.44v4.06c0 .315.262.578.577.578h1.75v-4.656h-2.328z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "M37.293 11.078h-2.328v31.517h2.327a4.653 4.653 0 0 0 4.655-4.655V15.715a4.653 4.653 0 0 0-4.655-4.655z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.965 11.078h-.875l-1.295-1.295a3.48 3.48 0 0 0-2.468-1.015h-4.655c-.962 0-1.837.385-2.467 1.015l-1.312 1.295H18.69a4.653 4.653 0 0 0-4.655 4.655v22.225a4.653 4.653 0 0 0 4.655 4.654h2.327l1.156-1.154 1.155 1.154h9.292l1.155-1.154 1.155 1.154a4.653 4.653 0 0 0 4.655-4.654L34.93 28l4.655-9.957v-2.328a4.653 4.653 0 0 0-4.655-4.655zm-4.655 2.327h-4.655A1.154 1.154 0 0 1 24.5 12.25c0-.63.525-1.155 1.155-1.155h4.655c.648 0 1.155.525 1.155 1.155s-.525 1.155-1.155 1.155"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M37.293 15.715h-2.328v24.553h2.327a2.34 2.34 0 0 0 2.328-2.328V18.043a2.34 2.34 0 0 0-2.328-2.328"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M37.292 37.958V18.043a2.326 2.326 0 0 0-2.327-2.328H18.707a2.326 2.326 0 0 0-2.327 2.328v19.915a2.326 2.326 0 0 0 2.327 2.327h2.328v2.328h2.327v-2.328h3.483v6.388c0 .314.262.577.577.577h1.155a.583.583 0 0 0 .578-.578v-6.387h3.482v2.328h2.328v-2.328a2.34 2.34 0 0 0 2.327-2.327"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "M31.045 21.595c-.21 0-.403 0-.613.053L28 34.51s6.965-4.042 6.965-8.977c0-2.17-1.75-3.92-3.92-3.92z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.655 25.533c0-1.96-.963-3.588-2.205-3.886a3.92 3.92 0 0 0-2.433 1.4 3.95 3.95 0 0 0-3.044-1.452 3.925 3.925 0 0 0-3.92 3.92c0 4.935 6.964 8.978 6.964 8.978s4.656-4.043 4.656-8.978z"
  })));
};
export default SvgIv;